import {
    toUpper
} from 'lodash';

export const ActionTypesFactory = (prefix, type) => {
    const p = `${toUpper(prefix)}/${toUpper(type)}`;
    return {
        REQUEST: `${p}_REQUEST`,
        INPROGRESS: `${p}_INPROGRESS`,
        SUCCESS: `${p}_SUCCESS`,
        FAILED: `${p}_FAILED`,
        CANCELLED: `${p}_CANCELLED`,
        RESET_ERROR: `${p}_RESET_ERROR`,
        custom: (name) => (`${p}_${name}`),
    };
};

// export const mockApi = (delay, response) => {
//     return wait(delay, response);
// };

export const wait = (delay, param) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(param);
            
        }, delay);
    });
};